<template>
  <div>
    <ts-page-title
      :title="$t('setupOffer.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        { text: $t('setupOffer.pageTitle'), active: true } //note
      ]"
    />

    <ts-panel>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew">{{
          $t('addNew')
        }}</Button>
        <div class="ts-space-x-2">
          <Input
            search
            v-model="search"
            :placeholder="$t('setupOffer.search')"
            :style="width"
            @on-focus="onSearchFocus()"
            @on-blur="() => (width = 'width: 300px')"
          />
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="product">
          {{ row.products ? row.products.product_name_en : ' ' }}
        </template>

        <template slot-scope="{ row }" slot="photo">
          <img
            :src="row.products ? row.products.photo : ''"
            style="height: 50px; width: 50px; border-radius: 50%; padding: 5px;"
            alt=""
          />
        </template>

        <template slot-scope="{ row }" slot="barcode">
          {{ row.products ? row.products.barcode : '' }}
        </template>

        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip
            confirm
            :title="$t('areYouSure')"
            @on-ok="onDelete(row)"
            :transfer="true"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
          >
            <a
              class="text-danger"
              v-tooltip="$t('delete')"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

      <a-modal
        v-model="showForm"
        v-if="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer="null"
        :z-index="1022"
        :closable="true"
        :title="$t('setupOffer.pageTitle')"
      >
        <from-action
          ref="form_action"
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FromAction from './form.vue'
import { debounce } from 'lodash'

export default {
  name: 'setup-offerIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('website/setupOffer', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.website.setupOffer.search
      },
      set(newValue) {
        this.$store.commit('website/setupOffer/SET_SEARCH', newValue)
        this.$store.commit('website/setupOffer/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('setupOffer.productPhoto'),
          slot: 'photo',
          width: 130
        },
        {
          title: this.$t('setupOffer.barcode'),
          slot: 'barcode',
          sortable: true,
          width: 120
        },
        {
          title: this.$t('setupOffer.productName'),
          slot: 'product',
          width: 200
        },
        {
          title: this.$t('setupOffer.description'),
          key: 'description'
        },

        {
          title: this.$t('actions'),
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('website/setupOffer/fetch', {
          ...attributes
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onEdit(record) {
      this.$store.commit('website/setupOffer/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.showForm = false
      this.$store.commit('website/setupOffer/SET_EDIT_DATA', {})
    },
    addNew() {
      this.$store.commit('website/setupOffer/SET_EDIT_DATA', {})
      this.showForm = true
    },

    onDelete(record) {
      record._deleting = true
      this.$store
        .dispatch('website/setupOffer/destroy', record.id)
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          record._deleting = false
          this.$toasted.error(error.message)
        })
    },
    onSearchFocus() {
      this.width = 'width: 500px'
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('website/setupOffer/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
